const prefix = "LEVY_COLLECTION_TEMPLATE_";

export const EDIT_GET_FAILED = prefix + "EDIT_GET_FAILED";
export const EDIT_GET_STARTED = prefix + "EDIT_GET_STARTED";
export const EDIT_GET_SUCCEEDED = prefix + "EDIT_GET_SUCCEEDED";
export const EDIT_SAVE_FAILED = prefix + "EDIT_SAVE_FAILED";
export const EDIT_SAVE_STARTED = prefix + "EDIT_SAVE_STARTED";
export const EDIT_SAVE_SUCCEEDED = prefix + "EDIT_SAVE_SUCCEEDED";
export const EDIT_SET_DATA = prefix + "EDIT_SET_DATA";
export const EXPORT_JSON_FAILED = prefix + "EXPORT_JSON_FAILED";
export const EXPORT_JSON_STARTED = prefix + "EXPORT_JSON_STARTED";
export const EXPORT_JSON_SUCCEEDED = prefix + "EXPORT_JSON_SUCCEEDED";
export const EXPORT_SPREADSHEET_FAILED = prefix + "EXPORT_SPREADSHEET_FAILED";
export const EXPORT_SPREADSHEET_STARTED = prefix + "EXPORT_SPREADSHEET_STARTED";
export const EXPORT_SPREADSHEET_SUCCEEDED = prefix + "EXPORT_SPREADSHEET_SUCCEEDED";
export const GET_BODY_TAGS_FAILED = prefix + "GET_BODY_TAGS_FAILED";
export const GET_BODY_TAGS_STARTED = prefix + "GET_BODY_TAGS_STARTED";
export const GET_BODY_TAGS_SUCCEEDED = prefix + "GET_BODY_TAGS_SUCCEEDED";
export const GET_SUBJECT_TAGS_FAILED = prefix + "GET_SUBJECT_TAGS_FAILED";
export const GET_SUBJECT_TAGS_STARTED = prefix + "GET_SUBJECT_TAGS_STARTED";
export const GET_SUBJECT_TAGS_SUCCEEDED = prefix + "GET_SUBJECT_TAGS_SUCCEEDED";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_FILTERS = prefix + "LIST_SET_FILTERS";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const PREVIEW_GET_FAILED = prefix + "PREVIEW_GET_FAILED";
export const PREVIEW_GET_STARTED = prefix + "PREVIEW_GET_STARTED";
export const PREVIEW_GET_SUCCEEDED = prefix + "PREVIEW_GET_SUCCEEDED";
export const PREVIEW_SEND_EMAIL_FAILED = prefix + "PREVIEW_SEND_EMAIL_FAILED";
export const PREVIEW_SEND_EMAIL_STARTED = prefix + "PREVIEW_SEND_EMAIL_STARTED";
export const PREVIEW_SEND_EMAIL_SUCCEEDED = prefix + "PREVIEW_SEND_EMAIL_SUCCEEDED";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const VIEW_CLEAR = prefix + "VIEW_CLEAR";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_NEXT = prefix + "VIEW_NEXT";
export const VIEW_PREVIOUS = prefix + "VIEW_PREVIOUS";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
